import { NavLink } from "react-router-dom";
import styled from "styled-components";
import {
  Body,
  primary01,
  shade0,
  shade300,
} from "@songtradr-one/components-frontend";
import { SubModuleType } from "@songtradr-one/shared-common";

// TEXT

// STYLES
export const Container = styled(NavLink)<ActiveProp>`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  text-decoration: none;

  ${({ $active }) =>
    !$active &&
    `
        &:focus-visible {
          box-shadow: inset 0 0 0 1px ${shade0};
        }
  `}
`;

export const Text = styled(Body)<{ $active: boolean }>`
  color: ${({ $active }) => ($active ? shade0 : shade300)};
  cursor: pointer;

  ${Container}:hover &,
  ${Container}:focus-visible & {
    color: ${shade0};
  }
`;

export const Dot = styled.div<ActiveProp>`
  height: 0.375rem;
  width: 0.375rem;
  background-color: ${({ $active }) => ($active ? primary01 : "transparent")};
  border-radius: 100%;
  flex-shrink: 0;
`;

// DATA

// TYPES
export type Props = {
  text: string;
  route: string;
  active: boolean;
  onClick?: () => void;
  type?: SubModuleType;
};

type ActiveProp = {
  $active: boolean;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
